import * as React from 'react'

const SvgFunnelIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.667"
      d="M1.667 3.833c0-.466 0-.7.09-.878a.833.833 0 01.365-.364C2.3 2.5 2.534 2.5 3 2.5h14c.467 0 .7 0 .879.09.156.08.284.208.364.365.09.178.09.412.09.878v.558c0 .224 0 .336-.027.44a.833.833 0 01-.118.259c-.06.089-.145.162-.314.309l-5.33 4.619c-.17.147-.254.22-.315.309a.833.833 0 00-.118.258c-.027.104-.027.216-.027.44v4.357c0 .163 0 .244-.027.315a.417.417 0 01-.11.163c-.055.05-.131.08-.282.141L8.83 17.134c-.306.123-.46.184-.582.159a.417.417 0 01-.263-.178c-.069-.105-.069-.27-.069-.6v-5.49c0-.223 0-.335-.027-.44a.832.832 0 00-.118-.258c-.061-.089-.146-.162-.315-.31L2.127 5.4c-.17-.147-.254-.22-.315-.31a.834.834 0 01-.118-.258c-.027-.104-.027-.216-.027-.44v-.558z"
    ></path>
  </svg>
)

export default SvgFunnelIcon
